<template>
  <div class="select-totem">
    <div class="login">
      <Header />

      <div class="bg-image"></div>

      <div class="login-area">
        <Loading v-if="isLoadingPage" text="Carregando..." />

        <div v-else class="section">
          <h1 class="white--text mb-7 text-center">
            Selecione um totem para iniciar
          </h1>

          <div class="card login-card py-14">
            <v-form ref="form" @submit.prevent="selectTotem">
              <v-select
                v-model="selectedTotem"
                :disabled="isLoading"
                label="Selecione um totem"
                :items="totens"
                item-text="name"
                :error-messages="
                  isDisplayErrorMessage ? 'Este campo é obrigatório' : ''
                "
              >
              </v-select>

              <v-btn
                class="btn mt-4"
                block
                color="primary"
                :disabled="isLoading"
                :loading="isLoading"
                type="submit"
                @click.right="selectTotem"
              >
                <img src="@/assets/ic-login.png" class="mr-2" alt="" />
                Entrar
                <template v-slot:loader>
                  <span>Carregando...</span>
                </template>
              </v-btn>
            </v-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTotens, updateStatusTotem } from "@/controllers/totem.controller";
import { signOut } from "@/controllers/admin.controller";

import Loading from "@/components/Loading/Loading";

import apiCard from "@/services/apiCard.service";

import adminStore from "@/store/admin.store";

export default {
  components: { Loading },
  data() {
    return {
      totens: [],
      totem: "",
      isLoading: false,
      signOut,
      isLoadingPage: true,
      selectedTotem: "",
      isDisplayErrorMessage: false,
      totemName: "",
    };
  },
  methods: {
    async selectTotem() {
      if (!this.selectedTotem) {
        this.isDisplayErrorMessage = true;
        return;
      }

      const totem = this.totens.find((t) => t.name === this.selectedTotem);

      this.totemName = totem.name;

      if (totem) {
        this.isLoading = true;

        await updateStatusTotem(totem, { isToCreateLog: true });

        this.isLoading = false;
        // Start api sitef
        try {
          await apiCard
          .post("/loadSitef", {
            typeOperation: 0,
            nameUser: this.totemName,
          })
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  watch: {
    selectedTotem: function () {
      this.isDisplayErrorMessage = false;
    },
  },
  async beforeMount() {
    const { id } = adminStore.getters.admin;
    if (!id) {
      this.$router.push("/signinadmin");
    }
    if (getTotens()) {
      this.totens = await getTotens();
      this.isLoadingPage = false;
    }
  },
};
</script>

<style scoped>
.white--text {
  color: #1a237e !important;
}
/* .login {
  overflow: hidden !important;
} */

/* .bg-image { */
  /* The image used */
  /* background-image: url("../../assets/background.png"); */

  /* Add the blur effect */
  /* filter: blur(24px); */
  /* -webkit-filter: blur(24px); */

  /* Full height */
  /* height: 100vh; */

  /* Center and scale the image nicely */
  /* background-position: center;
  background-repeat: no-repeat;
  background-size: cover; */
/* } */

/* .login-area {
  background-color: rgb(0, 0, 0); 
  background-color: rgba(1, 220, 252, 0.6); 
  color: white;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 100%;
  height: 100vh;
  padding: 20px;
  text-align: center;
  overflow: hidden !important;
} */

/* .section {
  position: absolute;
  top: 50%;
  width: 446px;
  height: 232px;
  left: 50%;
  transform: translate(-50%, -50%);
} */
</style>